import styled from "styled-components";

export const Play = styled('div')`
  padding: 0px;
  margin: 0px;
  border: 0px;
  width: 22px;
  height: 22px;
  border: 1px solid ${({ theme }) => theme.colors.Primary};
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border-radius: 100%;
  flex-shrink: 0;
  cursor: pointer;
  text-decoration: none;
`;
